import React from "react";
import { Rate } from "antd";
import styles from "./index.module.css";

const StarRatingUI = ({ value, onChange, allowHalf, disabled }) => {
  return (
    <Rate
      value={value}
      onChange={onChange}
      className={`text-yellow-400 text-xl ${styles.starSize}`}
      disabled={disabled}
      allowHalf={allowHalf}
    />
  );
};

export default StarRatingUI;
